import Lottie from 'lottie-react';

import lottieEvaluation from '../jsons/evaluations-empty.json';

const LottieEvaluationEmpty = props => {
  return <Lottie animationData={lottieEvaluation} loop={false} {...props} />;
};

export default LottieEvaluationEmpty;
